import styled, { theme, useThemeStore } from 'academy-common-lib/utils/Styling';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const ThemedPrimaryButtonMixin = () => {
  const {
    theme: themeName
  } = useThemeStore();
  return {
    '*': Object.assign({}, themeName === 'highContrast' && {
      backgroundColor: `${theme.colors.HIGH_CONTRAST_PRIMARY} !important`,
      borderColor: `${theme.colors.HIGH_CONTRAST_PRIMARY} !important`,
      ['&:hover']: {
        backgroundColor: `${theme.colors.HIGH_CONTRAST_HOVER} !important`,
        borderColor: `${theme.colors.HIGH_CONTRAST_HOVER} !important`,
        ['*']: {
          color: `${theme.colors.HIGH_CONTRAST_PRIMARY} !important`,
          backgroundColor: 'unset !important'
        }
      }
    })
  };
};
const StyledThemedPrimaryButton = styled.div.withConfig({
  displayName: "ThemedComponents__StyledThemedPrimaryButton"
})(() => Object.assign({}, ThemedPrimaryButtonMixin()));
export const ThemedSecondaryButtonMixinTrellis = () => {
  const {
    theme: themeName
  } = useThemeStore();
  return {
    '*': Object.assign({}, themeName === 'highContrast' && {
      color: `${theme.colors.HIGH_CONTRAST_PRIMARY} !important`,
      borderColor: `${theme.colors.HIGH_CONTRAST_PRIMARY} !important`,
      ['&:hover']: {
        backgroundColor: `${theme.colors.HIGH_CONTRAST_HOVER} !important`,
        ['*']: {
          color: `${theme.colors.HIGH_CONTRAST_PRIMARY} !important`
        }
      }
    })
  };
};
const StyledThemedSecondaryButton = styled.div.withConfig({
  displayName: "ThemedComponents__StyledThemedSecondaryButton"
})(() => Object.assign({}, ThemedSecondaryButtonMixinTrellis()));
export const ThemedLinkMixin = () => {
  const {
    theme: themeName
  } = useThemeStore();
  return Object.assign({}, themeName === 'highContrast' && {
    color: `${theme.colors.HIGH_CONTRAST_LINK} !important`
  });
};
export const StyledThemedLink = styled.div.withConfig({
  displayName: "ThemedComponents__StyledThemedLink"
})(() => Object.assign({}, ThemedLinkMixin()));
export const ThemedPrimaryButton = props => {
  return /*#__PURE__*/_jsx(StyledThemedPrimaryButton, {
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      use: "primary"
    }, props))
  });
};
export const ThemedSecondaryButton = props => {
  return /*#__PURE__*/_jsx(StyledThemedSecondaryButton, {
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      use: "secondary"
    }, props))
  });
};
export const ThemedLink = props => {
  return /*#__PURE__*/_jsx(StyledThemedLink, {
    children: /*#__PURE__*/_jsx(Link, Object.assign({}, props))
  });
};
export const ThemedRouterLink = props => {
  return /*#__PURE__*/_jsx(StyledThemedLink, {
    children: /*#__PURE__*/_jsx(RouterLink, Object.assign({}, props))
  });
};
export const ThemedPrimaryRouterButton = props => {
  return /*#__PURE__*/_jsx(StyledThemedPrimaryButton, {
    children: /*#__PURE__*/_jsx(RouterButton, Object.assign({}, props))
  });
};
const StyledThemedDropdown = styled.div.withConfig({
  displayName: "ThemedComponents__StyledThemedDropdown"
})(["", " padding:0 !important;margin:0 !important;"], props => props.theme.activeTheme === 'highContrast' && `*{
        color: ${theme.colors.HIGH_CONTRAST_LINK} !important;
      }`);
export const ThemedDropdown = props => {
  return (
    /*#__PURE__*/
    //@bend-expect trellis-tokenized
    _jsx(StyledThemedDropdown, {
      children: /*#__PURE__*/_jsx(Dropdown, Object.assign({}, props, {
        use: "unstyled"
      }))
    })
  );
};
const StyledThemedToggle = styled.div.withConfig({
  displayName: "ThemedComponents__StyledThemedToggle"
})(["", ""], props => props.theme.activeTheme === 'highContrast' && `
    [role=presentation]:nth-child(2) {
      background-color: ${theme.colors.HIGH_CONTRAST_LINK} !important;
    }
  `);
export const ThemedToggle = props => {
  return (
    /*#__PURE__*/
    //@bend-expect trellis-tokenized
    _jsx(StyledThemedToggle, {
      children: /*#__PURE__*/_jsx(Toggle, Object.assign({}, props))
    })
  );
};